import React from 'react';
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import EditableGridCell from './EditableGridCell';
import { FEditableGridColumn, FEditableGridRow } from './types';

import { clone } from '../../core/utils';
import { formatDate } from '../renderers';
import { createItemList, createObjectList, isValid } from '../form';
import EditableGridField from './EditableGridField';

type Props = {
  gform: FEditableGridColumn[];
  rows: FEditableGridRow[];
  readonly?: boolean;
  height?: number | string;
  onToggleRow: (rid: string, selected: boolean) => void;
  onChangeCell: (rid: string, colid: string, value: any) => void;
  [name:string]:any;
};

class EditableGridBody extends React.Component<Props, any> {
//gform:FEditableGridColumn, name?:string, title?:string, 
  formconfig = (gform:FEditableGridColumn[]) => {
    const {service,title} = this.props;
    const config = {
      service: {
        name: service,
        title: title,
        eform: gform,
      },
      create: true,
      actions: { add: 'Add' },
      panels: { add: 'simple' },
    };
    return config;
  }

  setValid = (data:any) => {
    const {gform} = this.props;
    const columns = gform.filter((col) => !col.hidden);

    const sconfig = this.formconfig(columns);
    const mode = 'add';
    const valid = isValid(sconfig,data,mode);
    this.props.setValid(valid);
  }

  onChange = (name:any) => (value:any) => {
    const {data} = this.props;
    const newdata = {...data.data,[name]:value};
    this.setValid(newdata);
    this.props.setItem('data','data',newdata);
  }

  onCellChange = (name:any) => (value:any) => {
    const {data} = this.props;
    const newdata = {...data.data,[name]:value};
    this.setValid(newdata);
    this.props.setItem('data','data',newdata);
  }

  makeform = (gform:FEditableGridColumn[]) => {
    const config = this.formconfig(gform);
    const { record = {} } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'add';
    const formatters = { dob: formatDate };
    const onChange = this.onChange.bind(this);
    // const form = create(mode,sdata,record,formatters,onChange,classes, extras);
    const  extras = {};
    const list = createItemList(mode,sdata,record,formatters,onChange, extras);
    return list;
  }

  makefields = (gform:FEditableGridColumn[]) => {
    const config = this.formconfig(gform);
    const { record = {}} = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'add';
    const formatters = { dob: formatDate };
    const onChange = this.onChange.bind(this);
    // const form = create(mode,sdata,record,formatters,onChange,classes, extras);
    const  extras = {};
    const list = createObjectList(mode,sdata,record,formatters,onChange, extras);
    return list;
  }

  onReset = (event:any) => {
    //reset for fields and data
  }

//const EditableGridTable: React.FC<Props> = ({ gform, rows, readonly, height, onToggleRow, onChangeCell }) => {
  render(){
    const { gform, rows, readonly, height, onToggleRow, onChangeCell } = this.props;
    const columns = gform.filter((col) => !col.hidden);

    const list = this.makeform(columns);
    const objects = this.makefields(columns);

    return (
      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: height || 520 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" />
              {columns.map((col) => <TableCell key={col.id} sx={{ minWidth: col.width || 150 }}>{col.label}{col.req ? ' *' : ''}</TableCell>)}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.filter((r) => r._state !== 'deleted').map((row) => (
              <TableRow key={row._rid} hover selected={Boolean(row._selected)}>
                <TableCell padding="checkbox"><Checkbox checked={Boolean(row._selected)} onChange={(e) => onToggleRow(row._rid, e.target.checked)} /></TableCell>
                {/* {columns.map((col) => ( */}
                {objects.map((ob:any,idx:number) => (
                  <TableCell key={`${row._rid}-${ob.fieldid}`}>
                    {/* <EditableGridCell column={col} value={row[col.id]} error={row._errors?.[col.id]} readonly={readonly} onChange={(value) => onChangeCell(row._rid, col.id, value)} /> */}
                    {/* {list.dom} */}
                    
                    {/* <EditableGridField fieldobject={ob} value={row[col.id]} error={row._errors?.[ob.fieldid]} readonly={readonly} onChange={(value) => onChangeCell(row._rid, col.id, value)} /> */}
                    <EditableGridField 
                      fieldobject={ob} 
                      value={row[ob.fieldid]} 
                      error={row._errors?.[ob.fieldid]} 
                      readonly={readonly} 
                      onChange={(value) => onChangeCell(row._rid, ob.fieldid, value)} 
                      //onChange={(value) => onChangeCell(row._rid, col.id, value)} 
                    />

                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default EditableGridBody;
